const UnauthenticatedHeader = (): JSX.Element => (
  <div style={rootStyles}>
    <div style={{ display: "flex" }}>
      <img style={logoStyles} src="./images/svg/eroad-logo-with-text.svg" alt="EROAD" />
    </div>
  </div>
);

const rootStyles = {
  backgroundColor: "#262626",
  display: "flex",
  flexShrink: 0,
  height: 64,
  padding: "0px 20px",
  width: "100%",
};

const logoStyles = {
  height: 40,
  width: "auto",
  alignSelf: "center",
};

export { UnauthenticatedHeader };
